import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext, useShowController } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import PhoneIcon from '@mui/icons-material/Phone'
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import EditIcon from '@mui/icons-material/Edit'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { blue } from 'src/assets/colors'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { CarForm } from 'src/components/pages/sales/reservation/logic/car/CarForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { EditOriginValues } from '../common/EditOriginValues'
import { guaranteeItemReservation } from 'src/components/pages/sales/reservation/helper/guaranteeItemReservation'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { Comment } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { itemServices } from 'src/services/reservation/item/item.service'
import { ComplementaryItemModal } from 'src/components/pages/sales/reservation/logic/modals/ComplementaryItemModal'
import { CreateItemSupplierModal } from 'src/components/pages/sales/reservation/logic/modals/CreateItemSupplierModal'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { INVOICED } from 'src/components/pages/sales/reservation/logic/common/state'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { CarCancellation } from './CarCancellation'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { ExchangeType } from '../common/ExchangeType'
import { CommentsCardComponent } from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { ItemCancellation } from '../common/AutoCancelFields'
import { afterSalesNewReservationItem } from '../../helper/afterSalesNewReservationItem'
import { ChangePaymentStatusDialog } from '../common/ChangePaymentStatusDialog'
import { ChangeBillingStatusDialog } from '../common/ChangeBillingStatusDialog'
import { LoadingButton } from '@mui/lab'

// const Pricing = () => {
//   const translate = useTranslate()
//   const car = useRecordContext()
//   if (car) {
//     return (
//       <>
//         {car?.pricing_relation?.[0]?.final_price !== 0 && car?.pricing_relation?.[0]?.final_price && (
//           <TableRow>
//             <TableCell>{translate('ra.field.commissionable_rate')}</TableCell>
//             <TableCell>
//               {' '}
//               <ShowElement
//                 source='pricing_relation[0].final_price'
//                 onlyValue
//                 blueText
//                 weightMoney
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         )}
//         {car?.pricing_relation?.[0]?.taxes_amount !== 0 && car?.pricing_relation?.[0]?.taxes_amount && (
//           <TableRow>
//             <TableCell>{translate('ra.field.taxes_amount')}</TableCell>
//             <TableCell>
//               {' '}
//               <ShowElement
//                 source='pricing_relation[0].taxes_amount'
//                 onlyValue
//                 blueText
//                 weightMoney
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         )}
//         {car?.pricing_relation?.[0]?.comision !== 0 && car?.pricing_relation?.[0]?.comision && (
//           <TableRow>
//             <TableCell>{translate('ra.field.comision')}</TableCell>
//             <TableCell>
//               {' '}
//               <ShowElement
//                 source='pricing_relation[0].comision'
//                 onlyValue
//                 blueText
//                 weightMoney
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         )}
//         {car?.pricing_relation?.[0]?.commission_percentage !== 0 &&
//           car?.pricing_relation?.[0]?.commission_percentage && (
//             <TableRow>
//               <TableCell>{translate('ra.field.commission_percentage')}</TableCell>
//               <TableCell>
//                 {' '}
//                 <ShowElement
//                   source='pricing_relation[0].commission_percentage'
//                   onlyValue
//                   blueText
//                   weightMoney
//                   styleValue={{ fontSize: '16px' }}
//                 />
//               </TableCell>
//             </TableRow>
//           )}
//         {car?.pricing_relation?.[0]?.net_price !== 0 && car?.pricing_relation?.[0]?.net_price && (
//           <TableRow>
//             <TableCell>{translate('ra.field.net_price_by_car')}</TableCell>
//             <TableCell>
//               {' '}
//               <ShowElement
//                 source='pricing_relation[0].net_price'
//                 onlyValue
//                 blueText
//                 weightMoney
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         )}
//         {car?.pricing_relation?.[0]?.additional_fare &&
//         car?.pricing_relation?.[0]?.additional_fare !== null ? (
//           <TableRow>
//             <TableCell>{translate('ra.field.additional_fare')}</TableCell>
//             <TableCell>
//               {' '}
//               <ShowElement
//                 data={
//                   car?.pricing_relation?.[0]?.additional_fare === 0
//                     ? 'Sin pago en destino'
//                     : car?.pricing_relation?.[0]?.additional_fare
//                 }
//                 onlyValue
//                 blueText={car?.pricing_relation?.[0]?.additional_fare === 0 ? false : true}
//                 weightMoney={car?.pricing_relation?.[0]?.additional_fare === 0 ? false : true}
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         ) : undefined}
//         {car?.pricing_relation?.[0]?.net_agency !== 0 && car?.pricing_relation?.[0]?.net_agency && (
//           <TableRow>
//             <TableCell>{translate('ra.field.net_agency')}</TableCell>

//             <TableCell>
//               {' '}
//               <ShowElement
//                 source='pricing_relation[0].net_agency'
//                 onlyValue
//                 blueText
//                 weightMoney
//                 styleValue={{ fontSize: '16px' }}
//               />
//             </TableCell>
//           </TableRow>
//         )}
//       </>
//     )
//   }
// }


const ReserveInformation = ({ reservation, refresh, isBillable, setIsBillable }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [changeStatusDialog, setChangeStatusDialog] = useState(false)
  const car = useRecordContext()
  const [loadingBillable, setLoadingBillable] = useState(false)
  const [changePaymentStatusDialog, setChangePaymentStatusDialog] = useState(false)
  const [changeBillingStatusDialog, setChangeBillingStatusDialog] = useState(false)

  const {
    isFetching
  } = useShowController()

  const onChangeBillable = async () => {
    const newValue = isBillable != undefined ? !isBillable : !car?.is_billable
    setIsBillable(newValue)
    setLoadingBillable(true)
    await reservationServices.updateIsBillableProduct(car.hash_, newValue).then(() => {
      notify('ra.notification.updated_success_masculine', {
        type: 'success',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    }).catch(() => {
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    }).finally(() => {
      setLoadingBillable(false)
    })
  }
  return (
    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
      <CompleteSideCard>
        <Box display={'flex'}>
          <LeftSideCard>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <ShowElement source='status' label={translate('ra.field.status')} />
              <HasPermission resource={'item'} permission='edit_status'>
                <EditIcon onClick={() => setChangeStatusDialog(true)} style={{ cursor: 'pointer', fontSize: '18px', color: '#6f7ce0', marginLeft: '15px' }} />
              </HasPermission>
            </div>
            <ShowElement
              source='created_at'
              label={translate('ra.field.created_at')}
              dateFormatCustom={timeZoneFormat}
            />
            <ShowElement
              source='issuance_datetime'
              label={translate('ra.field.date_emision')}
              dateFormatCustom={timeZoneFormat}
              nullNoShow={true}
            />
            <ShowElement
              source='source_relation.short_name'
              label={translate('ra.field.source')}
            />
          </LeftSideCard>
          <RigthSideCard>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <ShowElement
                source={'payment_status'}
                label={translate('ra.field.payment_status')}
                status
              />
              <HasPermission resource={'item'} permission='edit_payment_status'>
                <EditIcon onClick={() => setChangePaymentStatusDialog(true)} style={{ cursor: 'pointer', fontSize: '18px', color: '#6f7ce0', marginLeft: '15px' }} />
              </HasPermission>
            </div>
            <PassengerCar reservation={reservation} />
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <BillingStatusField />
                <HasPermission resource={'billing'} permission='edit_status'>
                  <EditIcon onClick={()=>setChangeBillingStatusDialog(true)} style={{cursor:'pointer', fontSize:'17px', color:'#6f7ce0', marginLeft:'12px'}}/>
                </HasPermission>
              </div>

            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
              <Box style={{ padding: '5px 0px 5px 0px' }}>
                <Typography
                  variant='h7'
                  component='span'
                  style={{
                    padding: '0px 5px 0px 5px',
                    fontWeight: 600,
                    flex: 1,
                    maxWidth: 'fit-content',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  {translate('ra.field.is_billable')}
                  <Checkbox
                    checked={isBillable != undefined ? isBillable : car?.is_billable}
                    onChange={onChangeBillable}
                    disabled={loadingBillable || isFetching}
                  />
                  {isFetching && (
                    <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />
                  )}
                </Typography>
              </Box>
            )}
            <BillingAutomaticField />
          </RigthSideCard>
        </Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
          {translate('ra.title.provider_info')}
        </Typography>
        <Box display={'flex'}>
          <LeftSideCard>
            <ShowElement
              source='supplier_relation.name'
              label={translate('ra.field.provider')}
            />
            <ShowElement
              source={'pricing_relation.[0].currency_origin'}
              label={translate('ra.field.currency')}
            />
          </LeftSideCard>
          <RigthSideCard>
            <ShowElement source={'code'} label={translate('ra.field.provider_code')} />
          </RigthSideCard>
        </Box>
      </CompleteSideCard>
      <ChangeStatusDialog
        open={changeStatusDialog}
        setOpen={setChangeStatusDialog}
        refresh={refresh}
      />
      <ChangePaymentStatusDialog
        open={changePaymentStatusDialog}
        setOpen={setChangePaymentStatusDialog}
        refresh={refresh}
      />
      <ChangeBillingStatusDialog
          open={changeBillingStatusDialog}
          setOpen={setChangeBillingStatusDialog}
          refresh={refresh}
      />

    </ShowCard>
  )
}

const PassengerCar = ({ reservation }) => {
  const car = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = car?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const DatesCar = () => {
  const car = useRecordContext()
  const translate = useTranslate()

  const concatDateTime = (date, time) => {
    if (time) {
      const timeAux = `${time.substring(0, 2)}:${time.substring(2)}`
      return `${date} ${timeAux}`
    }
    return ''
  }

  return (
    <>
      <ShowElement
        data={concatDateTime(car.date_in, car.time_in)}
        label={translate('ra.field.check_in_pick_up')}
        dateTime
      />
      <ShowElement
        data={concatDateTime(car.date_out, car.time_out)}
        label={translate('ra.field.check_in_drop_off')}
        dateTime
      />
    </>
  )
}

const ContextCar = ({ reservation }) => {
  const car = useRecordContext()
  if (car) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        {/* <CarCancellation autoCancelDate={car?.autocancel_date} cancellations={car?.cancel_info_relation} /> */}
        <ItemCancellation autoCancelDate={car?.autocancel_date} cancellations={car?.cancel_info_relation}/>
        <Passenger itemId={car.item_id} passengers={car?.pax_relation} idResource={reservation?.id} />
      </>
    )
  }
}

const ContextCarForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const car = useRecordContext()
  if (car && openProductModal) {
    return (
      <CarForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={car}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={car}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({ work_unit_relation, enableReliquidation }) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)

  const onReliquidate = async () => {
    setReliquidateLoading(true)
    if (reliquidateType === 0) {
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(() => {
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation + 1)
        }, 2000);
      }).catch(() => {
        notify('ra.message.reliquidation_error', { type: 'error' })
      }).finally(() => {
        setReliquidateLoading(false)
      })
    }
    else if (reliquidateType === 1) {
      await pricingServices.reliquidate_retail([item.hash_]).then(() => {
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation + 1)
        }, 2000);
      }).catch(() => {
        notify('ra.message.reliquidation_error', { type: 'error' })
      }).finally(() => {
        setReliquidateLoading(false)
      })
    }
    else if (reliquidateType === 2) {
      await pricingServices.reliquidate_supplier([item.hash_]).then(() => {
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation + 1)
        }, 2000);
      }).catch(() => {
        notify('ra.message.reliquidation_error', { type: 'error' })
      }).finally(() => {
        setReliquidateLoading(false)
      })
    }

  }

  useEffect(() => {
    if (confirmReliquidate) {
      onReliquidate()
    }
  }, [confirmReliquidate])

  const decideLiquidation = () => {
    if (reliquidateType === 0) {
      return translate('ra.title.liquidation_wholesaler')
    }
    if (reliquidateType === 1) {
      return translate('ra.title.liquidation_retail')
    }
    if (reliquidateType === 2) {
      return translate('ra.title.liquidation_supplier')
    }
  }

  const handleCLickRule = (ruleId) => {
    if (ruleId) {
      window.open(`/#/business-rule/${ruleId}`, '_blank')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{ cursor: hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default' }}
                  onClick={async () => {
                    if (hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation) {
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_wholesaler'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{ cursor: hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default' }}
                  onClick={async () => {
                    if (hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation) {
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              posTitle={
                <HasPermission resource={'business-rule'} permission='view'>
                  <Box sx={{ flex: 1, textAlign: 'end' }}>
                    <Button
                      variant='text'
                      onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied)}
                    >
                      {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied}
                    </Button>
                  </Box>
                </HasPermission>
              }
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing
                      node_liquidation='liquidation_retail'
                      work_unit_relation={work_unit_relation}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
              <AttachMoneyIcon
                color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                style={{ cursor: hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default' }}
                onClick={async () => {
                  if (hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation) {
                    setOpenReliquidateModal(true)
                    setReliquidateType(2)
                  }
                }}
              />
            </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_supplier'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', { liquidation: decideLiquidation() })}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const car = useRecordContext()
  if (car) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={car} />
      </ShowCard>
    )
  }
}

export const CarProduct = ({ reservation, car, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState(false)
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [confirm, setConfirm] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)

  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [confirmEmit, setConfirmEmit] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)
  const [wasEmitted, setWasEmitted] = useState({})
  const [reservationNumberMove, setReservationNumberMove] = useState('')
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)

  // const [exchangeMode, setExchangeMode] = useState(false)
  const [openProductModal, setOpenProductModal] = useState(false)
  const { setOpenDueDateModal } = useReservationInfo()
  const { setCardLoading } = useCardLoading()

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openAfterSalesItemModal, setOpenAfterSalesItemModal] = useState(false)
  const [confirmAfterSalesItem, setConfirmAfterSalesItem] = useState(false)
  const [loadingAfterSalesReservationItem, setLoadingAfterSalesReservationItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [isBillable, setIsBillable] = useState()

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  const [openComplementaryModal, setOpenComplementaryModal] = useState(false)
  const [loadingComplementaryItem, setLoadingComplementaryItem] = useState(false)
  const [openCreateItemSupplierModal, setOpenCreateItemSupplierModal] = useState(false)
  const [itemSupplierItemId, setItemSupplierItemId] = useState(null)

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)
    if (car && Array.isArray(car) && car.length > 0 && wasEmittedKeys.length > 0) {
      wasEmittedKeys.forEach((emit) => {
        const isEmmited = car.find((elem) => elem?.hash_ === emit && elem?.status === INVOICED)
        if (wasEmitted[emit] && isEmmited) {
          setWasEmitted((prev) => ({
            ...prev,
            [emit]: false,
          }))
          setLoadingEmitItem(false)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [car, wasEmitted])

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmAfterSalesItem) {
      afterSalesNewReservationItem({
        hashItemReserve,
        refresh,
        notify,
        setLoadingAfterSalesReservationItem,
        setHashItemReserve,
        setConfirmAfterSalesItem,
        setOpenAfterSalesItemModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSalesItem])

  useEffect(() => {
    if (confirmRegisterReturn) {
      registerReturn({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRegisterReturnItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmRegisterReturn,
        setOpenRegisterReturnModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if (error.response.data?.detail) {
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
        setOpenMoveModal(false)
      }
    }
  }

  if (car) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingCancelItem || loadingDeleteItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <TabProduct
          products={car}
          labelGetter={(product) => (product?.id_detail ? product?.provider : 'ERROR')}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='car-detail'
              loadingCancel={loadingCancelItem}
              onCancel={(car) => {
                setOpen(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              onDeleted={(car) => {
                setOpenDeleteModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(car) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onClone={(car) => {
                setOpenCloneModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              loadingCloneItem={loadingCloneItem}
              onMove={(car) => {
                setOpenMoveModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              loadingMoveItem={loadingMoveItem}
              onEmit={(car) => {
                setOpenEmitModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }}
              loadingEmitItem={loadingEmitItem}
              reservation={reservation}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(car) => {
                setOpenAfterSalesModal(true)
                setHashItemReserve(car?.hash_)
                setNameReserve(car?.provider)
              }
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (car) => {
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(car?.hash_)
                  setNameReserve(car?.provider)
                }
              }
              loadingRegisterReturn={loadingRegisterReturnItem}
              setLoadingRegisterReturn={setLoadingRegisterReturnItem}
              postventaStatusButton={(car) => {
                setChangePostventaStatus(true)
                setHashItemReserve(car?.hash_)
                setActualStatus(car.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
              onAfterSalesItem={(car) => {
                setOpenAfterSalesItemModal(true)
                setHashItemReserve(car?.hash_)
              }
              }
              onComplementary={(car) => {
                setOpenComplementaryModal(true)
                setHashItemReserve(car?.hash_)
              }}
              loadingComplementaryItem={loadingComplementaryItem}
              onItemSupplierCreate={(car) => {
                setItemSupplierItemId(car?.item_id ?? car?.id)
                setOpenCreateItemSupplierModal(true)
              }}
            />
          )}
          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextCarForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1} style={{ borderBottomColor: 'red' }}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ReserveInformation
                      reservation={reservation}
                      refresh={refresh}
                      isBillable={isBillable}
                      setIsBillable={setIsBillable}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>{translate('ra.title.price_history')}
                        <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { setHistoryCostsDialog(false) }} />
                      </DialogTitle>
                      <DialogContent>
                        <HistoryCostsDialog />
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.new_after_sales_item_confirmation')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesItemModal}
                      setConfirm={setConfirmAfterSalesItem}
                      open={openAfterSalesItemModal}
                      loadingModalButton={loadingAfterSalesReservationItem}
                    />

                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <LoadingButton loading={loadingMoveItem}  variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </LoadingButton>
                      </DialogActions>
                    </Dialog>
                    <ComplementaryItemModal
                      open={openComplementaryModal}
                      hashItem={hashItemReserve}
                      onClose={() => setOpenComplementaryModal(false)}
                    />
                    <CreateItemSupplierModal
                      open={openCreateItemSupplierModal}
                      itemId={itemSupplierItemId}
                      onClose={() => setOpenCreateItemSupplierModal(false)}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard iconHeader={<TimeToLeaveIcon />} title={translate('ra.title.car_information')}>
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement source='driver_name' label={translate('ra.field.driver_name')} />
                            <ShowElement
                              source='driver_lastname'
                              label={translate('ra.field.driver_lastname')}
                            />
                            <ShowElement source='driver_age' label={translate('ra.field.driver_age')} />
                            <ShowElement
                              source='driver_document'
                              label={translate('ra.field.driver_document')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source='provider'
                              label={translate('ra.field.renter')}
                              blueText
                              strong
                            />
                            <ShowElement source='coverage' label={translate('ra.field.coverage')} />
                            <ShowElement source='name' label={translate('ra.field.car_name')} />
                            <ShowElement source='type' label={translate('ra.field.type')} />
                          </RigthSideCard>
                        </Box>
                        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                          {translate('ra.title.trip_car_information')}
                        </Typography>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement source='pick_up_address' label={translate('ra.field.pick_up')} />
                            <ShowElement source='drop_off_address' label={translate('ra.field.drop_off')} />
                          </LeftSideCard>
                          <RigthSideCard>
                            <DatesCar />
                          </RigthSideCard>
                        </Box>
                        <ContextCar reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <CommentsCardComponent />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    actionButtonIcon={<EditIcon />}
                    optionHeigth={'pricing'}
                    variant='text'
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    reservation={reservation}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='revision' resource={'pricing'}>
                          <Button
                            onClick={() => { setHistoryCostsDialog(true) }}
                            sx={{ paddingX: '10px', marginX: '5px' }}
                            size='small'
                            variant='contained'
                          >
                            {translate('ra.title.price_history')}
                          </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal} />
                    </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} work_unit_relation={reservation?.work_unit_relation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
